import { ALL_ROUTES } from './navigation';
import type { CommandPaletteSearchResult } from '../../../../shared/CommandPalette/types';

/**
 * Returns all navigable routes.
 */
export function useNavigableRoutes(): CommandPaletteSearchResult[] {
  // Filter out routes that should not be navigable.
  // If the shouldEnable is not defined, it is navigable.
  // Otherwise, only return the route if shouldEnable returns true.
  return Array.from(ALL_ROUTES.values()).filter((route) => route.shouldEnable());
}

export default useNavigableRoutes;
